// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.failresdiv {
  margin-left: 25px;
  padding-right: 33px;
}

.failresheader {
  background-color: #007887;
}

.failrestitle {
  font-size: 14px;
  color: white;
  border-radius: 2px;
  text-align: center;
}

.failresbodylist {
  min-height: 68vh;
  max-height: 68vh;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  border-bottom: 2px solid #007887;
  border-left: 2px solid #007887;
  border-right: 2px solid #007887;
  border-radius: 2px;
}

::-webkit-scrollbar {
  width: 3px !important;
}

.failresbody {
  min-height: 68vh;
  max-height: 68vh;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  border-bottom: 2px solid #007887;
  border-right: 2px solid #007887;
  border-radius: 2px;
}

.highchart {
  border: 2px solid #007887;
  font-size: 11px;
  min-height: 280px;
  max-height: 280px;
  margin-left: 4%;
}

.editorht {
  max-height: 63vh;
  min-height: 63vh;
}

.active_cardcolor {
  background-color: #C3EFF4;
  font-size: 12px;
}

.text2lineellips {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 40px;
  line-height: 22px;
}

::ng-deep.diffeditor .monaco-diff-editor .overflow-guard {
  width: 438px !important;
}
::ng-deep.diffeditor .monaco-diff-editor .overflow-guard .monaco-scrollable-element {
  width: 390px !important;
}

::ng-deep.diffeditorlinebyline .monaco-diff-editor .overflow-guard {
  width: 774px !important;
}
::ng-deep.diffeditorlinebyline .monaco-diff-editor .overflow-guard .monaco-scrollable-element {
  width: 726px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/newaudit/newaudit.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;EAAkB,mBAAA;AAEtB;;AAAE;EACE,yBAAA;AAGJ;;AAAI;EACI,eAAA;EAAgB,YAAA;EAAa,kBAAA;EAAmB,kBAAA;AAMxD;;AAHM;EACE,gBAAA;EAAiB,gBAAA;EAClB,6BAAA;EAA8B,2BAAA;EAC7B,gCAAA;EACA,8BAAA;EACA,+BAAA;EACA,kBAAA;AAQR;;AANM;EACE,qBAAA;AASR;;AAPM;EACE,gBAAA;EAAiB,gBAAA;EAClB,6BAAA;EAA8B,2BAAA;EAC7B,gCAAA;EACA,+BAAA;EACA,kBAAA;AAYR;;AAVM;EACE,yBAAA;EACE,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;AAaV;;AAXM;EACE,gBAAA;EACA,gBAAA;AAcR;;AAXM;EACE,yBAAA;EACA,eAAA;AAcR;;AAZM;EACM,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;AAeZ;;AAOE;EACE,uBAAA;AAJJ;AAKI;EACE,uBAAA;AAHN;;AAYI;EACE,uBAAA;AATN;AAUM;EACE,uBAAA;AARR","sourcesContent":[".failresdiv{\r\n    margin-left: 25px;padding-right: 33px;\r\n  }\r\n  .failresheader{\r\n    background-color: #007887;\r\n    }\r\n\r\n    .failrestitle{\r\n        font-size: 14px;color: white;border-radius: 2px;text-align: center;\r\n      }\r\n      \r\n      .failresbodylist{\r\n        min-height: 68vh;max-height: 68vh;\r\n       overflow-x: hidden !important;overflow-y: auto !important;\r\n        border-bottom: 2px solid #007887;\r\n        border-left: 2px solid #007887;\r\n        border-right: 2px solid #007887;\r\n        border-radius: 2px;\r\n      }\r\n      ::-webkit-scrollbar {\r\n        width: 3px !important;\r\n      }\r\n      .failresbody{\r\n        min-height: 68vh;max-height: 68vh;\r\n       overflow-x: hidden !important;overflow-y: auto !important;\r\n        border-bottom: 2px solid #007887;\r\n        border-right: 2px solid #007887;\r\n        border-radius: 2px;\r\n      }\r\n      .highchart{\r\n        border: 2px solid #007887;\r\n          font-size: 11px;\r\n          min-height: 280px;\r\n          max-height: 280px;\r\n          margin-left:4%;\r\n      }\r\n      .editorht{\r\n        max-height: 63vh;\r\n        min-height: 63vh;\r\n      }\r\n\r\n      .active_cardcolor{\r\n        background-color: #C3EFF4;\r\n        font-size: 12px;\r\n      }\r\n      .text2lineellips{\r\n            display: -webkit-box;\r\n            -webkit-line-clamp: 2;\r\n            -webkit-box-orient: vertical;\r\n            overflow: hidden;\r\n            text-overflow: ellipsis;\r\n            height: 40px;\r\n            line-height: 22px;\r\n      }\r\n\r\n    // ::ng-deep.failresbody  .td-wrapper{\r\n    //     display: grid !important;\r\n    // width: 100% !important;\r\n    // grid-row-gap: 1px !important;\r\n    // grid-template-columns: repeat(2,[col] 50%) !important;\r\n    // grid-template-rows: repeat(2,[row] auto) !important;\r\n    // background-color: #fff !important;\r\n    // color: #444 !important;\r\n    //   }\r\n    //   ::ng-deep.failresbody  .td-checkbox-container{\r\n    //     font-size: 14px !important;\r\n    // line-height: 22px !important;\r\n    //   }\r\n    //   ::ng-deep.failresbody  .checkmark{\r\n    //     top: 3px !important;\r\n    //   }\r\n\r\n::ng-deep.diffeditor{\r\n.monaco-diff-editor{\r\n  .overflow-guard{\r\n    width: 438px !important;\r\n    .monaco-scrollable-element{\r\n      width: 390px !important;\r\n    }\r\n  }\r\n  \r\n}\r\n}\r\n\r\n::ng-deep.diffeditorlinebyline{\r\n  .monaco-diff-editor{\r\n    .overflow-guard{\r\n      width: 774px !important;\r\n      .monaco-scrollable-element{\r\n        width: 726px !important;\r\n      }\r\n    }\r\n  }\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
